
import utils from '@/mixins/utils'
import Standfirst from '@/components/Standfirst'
import Hero from '@/components/Hero'
export default {

  components: {
    Standfirst,
    Hero,
  },
  mixins: [utils],

  props: {
    data: {
      type: Object,
      default: () => {
        return null
      },
    },
  },
  mounted() {
    if (window && this.data.booking) {
      if (window.HOLDBAR) {
        const widget = this.$refs['booking-widget'] ? [this.$refs['booking-widget']] : []
        if (widget) {
          const currLang = window.Weglot.getCurrentLang() || 'en'
          const widgetLang = widget[0].dataset.language
          if (widgetLang !== currLang) {
            widget[0].dataset.language = currLang
          }

          if (widget[0] && !widget[0].shadowRoot) {
            window.HOLDBAR.initialize()
          }
        }
      }
    }
  },
}
